<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="heading mb-0">Properties Report</h5>
          <div class="d-flex gap-2 align-items-center" *ngIf="checkDownloadPermission">
            <button class="btn btn-outline-danger btn-sm" (click)="downloadReport('pdf')" [disabled]="isDownloading">
              <span *ngIf="isDownloading && activeDownloadType === 'pdf'" class="spinner-border spinner-border-sm me-1"></span>
              <i class="bi bi-file-earmark-pdf me-1" *ngIf="!isDownloading || activeDownloadType !== 'pdf'"></i>PDF
            </button>
            <button class="btn btn-outline-success btn-sm" (click)="downloadReport('csv')" [disabled]="isDownloading">
              <span *ngIf="isDownloading && activeDownloadType === 'csv'" class="spinner-border spinner-border-sm me-1"></span>
              <i class="bi bi-file-earmark-spreadsheet me-1" *ngIf="!isDownloading || activeDownloadType !== 'csv'"></i>CSV
            </button>
            <button class="btn btn-outline-primary btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
              <i class="bi bi-envelope me-1"></i> Email
            </button>
            <button class="btn btn-outline-success btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
              <i class="bi bi-whatsapp me-1"></i> WhatsApp
            </button>
            <span *ngIf="isDownloading" class="text-muted small ms-2">{{ downloadProgress }}</span>
          </div>
        </div>

        <!-- Filters -->
        <form [formGroup]="filterForm">
          <div class="row g-2 mb-3">
            <div class="col-md-2 col-sm-6">
              <label class="form-label">Search</label>
              <input type="text" class="form-control form-control-sm" formControlName="search"
                placeholder="Property name..." (input)="onTextFilterChange()">
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">City</label>
              <input type="text" class="form-control form-control-sm" formControlName="city"
                placeholder="City..." (input)="onTextFilterChange()">
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">Status</label>
              <ng-select formControlName="status" [items]="statusOptions" bindLabel="label" bindValue="value"
                placeholder="All" (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">Category</label>
              <ng-select formControlName="category" [items]="categoryOptions" bindLabel="label" bindValue="value"
                [multiple]="true" [closeOnSelect]="false" placeholder="All"
                (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">Listing Status</label>
              <ng-select formControlName="listing_status" [items]="listingStatusOptions" bindLabel="label" bindValue="value"
                placeholder="All" (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">Owner</label>
              <ng-select formControlName="has_owner" [items]="hasOwnerOptions" bindLabel="label" bindValue="value"
                placeholder="All" (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-2 col-sm-6">
              <label class="form-label">ID Proof Attached</label>
              <ng-select formControlName="id_proof_attached" [items]="idProofOptions" bindLabel="label" bindValue="value"
                placeholder="All" (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-3 col-sm-6">
              <label class="form-label">Managed By</label>
              <ng-select formControlName="managed_by" [items]="managersItems" bindLabel="label" bindValue="value"
                placeholder="All Managers" [multiple]="true" [closeOnSelect]="false" [virtualScroll]="true"
                (scrollToEnd)="onManagerScrollEnd()" (search)="searchManager$.next($event.term)"
                (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-1 col-sm-6 d-flex align-items-end">
              <button class="btn btn-outline-secondary btn-sm w-100" (click)="resetFilters()" [disabled]="!disableClear">Clear</button>
            </div>
          </div>
        </form>

        <!-- Summary Cards -->
        <div class="d-flex flex-wrap gap-2 mb-3" *ngIf="summaryData">
          <div class="summary-card bg-primary text-white">
            <div class="summary-value">{{ summaryData.total_properties }}</div>
            <div class="summary-label">Total Properties</div>
          </div>
          <div *ngFor="let card of categoryCards" class="summary-card clickable" [ngClass]="card.bgClass"
            [class.active]="isCategorySelected(card.key)" (click)="onCategoryCardClick(card.key)"
            [title]="'Click to filter by ' + card.key">
            <div class="summary-value">{{ getCategoryCount(card.key) }}</div>
            <div class="summary-label">{{ card.key }}</div>
          </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs mb-0">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'all'" (click)="switchTab('all')" href="javascript:void(0)">All Properties</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-status'" (click)="switchTab('by-status')" href="javascript:void(0)">By Status</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-city'" (click)="switchTab('by-city')" href="javascript:void(0)">By City</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-category'" (click)="switchTab('by-category')" href="javascript:void(0)">By Category</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'graphs'" (click)="switchTab('graphs')" href="javascript:void(0)">Graphs</a>
          </li>
        </ul>

        <div class="tab-content">

          <!-- All Properties Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'all'">
            <div class="table-responsive">
              <table class="table table-hover table-sm mt-2">
                <thead>
                  <tr>
                    <th>Property Name</th>
                    <th>City</th>
                    <th>Status</th>
                    <th>Category</th>
                    <th>Listing Status</th>
                    <th>Type</th>
                    <th>Has Owner</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of reportData">
                    <td>{{ row.name }}</td>
                    <td>{{ row.city || '-' }}</td>
                    <td><span class="badge" [ngClass]="getStatusClass(row.status)">{{ row.status }}</span></td>
                    <td>{{ row.category || '-' }}</td>
                    <td>{{ row.listing_status || '-' }}</td>
                    <td>{{ row.type || '-' }}</td>
                    <td><span class="badge" [ngClass]="row.owner_id ? 'badge-success' : 'badge-secondary'">{{ row.owner_id ? 'Yes' : 'No' }}</span></td>
                  </tr>
                  <tr *ngIf="reportData.length === 0">
                    <td colspan="7" class="text-center text-muted py-3">No properties found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="dataTables_paginate" *ngIf="pageCount > 1">
              <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
            </div>
          </div>

          <!-- By Status Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'by-status'">
            <div class="table-responsive">
              <table class="table table-hover table-sm mt-2">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th class="text-end">Total Properties</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let entry of getSummaryEntries(summaryData?.count_by_status)">
                    <td><span class="badge" [ngClass]="getStatusClass(entry.key)">{{ entry.key }}</span></td>
                    <td class="text-end">{{ entry.value }}</td>
                  </tr>
                  <tr *ngIf="!summaryData || getSummaryKeys(summaryData.count_by_status).length === 0">
                    <td colspan="2" class="text-center text-muted py-3">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- By City Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'by-city'">
            <div class="table-responsive">
              <table class="table table-hover table-sm mt-2">
                <thead>
                  <tr>
                    <th>City</th>
                    <th class="text-end">Total Properties</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let entry of getSummaryEntries(summaryData?.count_by_city)">
                    <td>{{ entry.key }}</td>
                    <td class="text-end">{{ entry.value }}</td>
                  </tr>
                  <tr *ngIf="!summaryData || getSummaryKeys(summaryData.count_by_city).length === 0">
                    <td colspan="2" class="text-center text-muted py-3">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- By Category Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'by-category'">
            <div class="table-responsive">
              <table class="table table-hover table-sm mt-2">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th class="text-end">Total Properties</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let entry of getSummaryEntries(summaryData?.count_by_category)">
                    <td>{{ entry.key }}</td>
                    <td class="text-end">{{ entry.value }}</td>
                  </tr>
                  <tr *ngIf="!summaryData || getSummaryKeys(summaryData?.count_by_category).length === 0">
                    <td colspan="2" class="text-center text-muted py-3">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Graphs Tab -->
          <div class="tab-pane" [class.active]="activeTab === 'graphs'">
            <div class="row mt-3" *ngIf="summaryData">
              <div class="col-md-6 mb-3">
                <div class="card">
                  <div class="card-header"><h5 class="mb-0">Properties by Status</h5></div>
                  <div class="card-body chart-container">
                    <div class="chart-bars">
                      <div class="chart-bar-item" *ngFor="let entry of getSummaryEntries(summaryData.count_by_status)">
                        <span class="chart-bar-label">{{ entry.key }}</span>
                        <div class="chart-bar-wrapper">
                          <div class="chart-bar"
                            [style.width.%]="summaryData.total_properties > 0 ? (entry.value / summaryData.total_properties) * 100 : 0"
                            [ngClass]="{
                              'bg-info': entry.key === 'Work in Progress',
                              'bg-warning': entry.key === 'Pending',
                              'bg-success': entry.key === 'Approved',
                              'bg-secondary': entry.key === 'Archived',
                              'bg-primary': entry.key === 'Enquiry'
                            }">
                          </div>
                          <span class="chart-bar-value">{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="card">
                  <div class="card-header"><h5 class="mb-0">Properties by Category</h5></div>
                  <div class="card-body chart-container">
                    <div class="chart-bars">
                      <div class="chart-bar-item" *ngFor="let entry of getSummaryEntries(summaryData.count_by_category)">
                        <span class="chart-bar-label">{{ entry.key }}</span>
                        <div class="chart-bar-wrapper">
                          <div class="chart-bar bg-primary"
                            [style.width.%]="summaryData.total_properties > 0 ? (entry.value / summaryData.total_properties) * 100 : 0">
                          </div>
                          <span class="chart-bar-value">{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="card">
                  <div class="card-header"><h5 class="mb-0">Properties by City</h5></div>
                  <div class="card-body chart-container">
                    <div class="chart-bars">
                      <div class="chart-bar-item" *ngFor="let entry of getSummaryEntries(summaryData.count_by_city)">
                        <span class="chart-bar-label">{{ entry.key }}</span>
                        <div class="chart-bar-wrapper">
                          <div class="chart-bar bg-info"
                            [style.width.%]="summaryData.total_properties > 0 ? (entry.value / summaryData.total_properties) * 100 : 0">
                          </div>
                          <span class="chart-bar-value">{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="card">
                  <div class="card-header"><h5 class="mb-0">Properties by Listing Status</h5></div>
                  <div class="card-body chart-container">
                    <div class="chart-bars">
                      <div class="chart-bar-item" *ngFor="let entry of getSummaryEntries(summaryData.count_by_listing_status)">
                        <span class="chart-bar-label">{{ entry.key }}</span>
                        <div class="chart-bar-wrapper">
                          <div class="chart-bar bg-success"
                            [style.width.%]="summaryData.total_properties > 0 ? (entry.value / summaryData.total_properties) * 100 : 0">
                          </div>
                          <span class="chart-bar-value">{{ entry.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!summaryData" class="text-center text-muted py-4">No data available for charts</div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Share Modal -->
  <div class="modal d-block" tabindex="-1" role="dialog" *ngIf="showShareModal" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Share Report via {{ shareType === 'email' ? 'Email' : 'WhatsApp' }}</h5>
          <button type="button" class="btn-close" (click)="closeShareModal()"></button>
        </div>
        <form [formGroup]="shareForm">
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Search User</label>
              <ng-select formControlName="selectedUser" [items]="managersItems" bindLabel="label" bindValue="value"
                placeholder="Search by name..." (search)="searchManager$.next($event.term)"
                (change)="onShareUserChange($event)" class="select2-sm">
              </ng-select>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label class="form-label">First Name</label>
                <input type="text" class="form-control form-control-sm" formControlName="first_name" placeholder="First name">
              </div>
              <div class="col-6">
                <label class="form-label">Last Name</label>
                <input type="text" class="form-control form-control-sm" formControlName="last_name" placeholder="Last name">
              </div>
            </div>
            <div class="mb-3" *ngIf="shareType === 'email'">
              <label class="form-label">Email Address</label>
              <input type="email" class="form-control form-control-sm" formControlName="email" placeholder="Enter email">
            </div>
            <div class="mb-3" *ngIf="shareType === 'whatsapp'">
              <div class="row">
                <div class="col-4">
                  <label class="form-label">Code</label>
                  <input type="text" class="form-control form-control-sm" formControlName="country_code" placeholder="+91">
                </div>
                <div class="col-8">
                  <label class="form-label">WhatsApp Number</label>
                  <input type="text" class="form-control form-control-sm" formControlName="whatsapp" placeholder="Enter number">
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">File Type</label>
              <ng-select formControlName="file_type" [items]="reportTypeOptions" bindLabel="label" bindValue="value"
                [clearable]="false" class="select2-sm">
              </ng-select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" (click)="closeShareModal()">Cancel</button>
            <button type="button" class="btn btn-primary btn-sm" (click)="submitShare()">
              <i class="bi" [ngClass]="{'bi-envelope': shareType === 'email', 'bi-whatsapp': shareType === 'whatsapp'}"></i> Send
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
